import {
	ShoppingCartConfigurationBundleDto,
	ShoppingCartConfigurationBundleProductCharacteristicDto,
	ShoppingCartConfigurationBundleProductCharacteristicGroupDto,
	ShoppingCartConfigurationBundleProductDto,
	ShoppingCartConfigurationBundleProductServiceSpecificationDto,
	UpdateShoppingCartConfigurationBundleDto,
	UpdateShoppingCartConfigurationBundleProductCharacteristicDto,
	UpdateShoppingCartConfigurationBundleProductDto,
	UpdateShoppingCartConfigurationBundleProductServiceSpecificationDto,
	UpdateShoppingCartConfigurationDto
} from "@/api/models/shoppingCart.model";
import { ServiceSpecificationType } from "../constants/enums";

export function mapShoppingCartConfigurationBundlesToUpdate(bundles: ShoppingCartConfigurationBundleDto[] = []): UpdateShoppingCartConfigurationDto {
	return {
		bundles: bundles.map(mapShoppingCartConfigurationBundleDtoToUpdate)
	};
}

const mapShoppingCartConfigurationBundleDtoToUpdate = (bundle: ShoppingCartConfigurationBundleDto): UpdateShoppingCartConfigurationBundleDto => {
	const { id, name, products = [] } = bundle;

	return {
		id,
		name,
		products: products.map(mapShoppingCartConfigurationBundleProductDtoToUpdate)
	};
};

function mapShoppingCartConfigurationBundleProductDtoToUpdate(
	product: ShoppingCartConfigurationBundleProductDto
): UpdateShoppingCartConfigurationBundleProductDto {
	const { id, name, characteristics = [], characteristicGroups = [], serviceSpecification = [] } = product;

	return {
		id,
		name,
		characteristics: mapShoppingCartConfigurationBundleProductCharacteristicsToUpdate({ characteristics, characteristicGroups }),
		serviceSpecification: serviceSpecification
			.filter((item) => item.hidden === false)
			.map(mapShoppingCartConfigurationBundleProductServiceSpecificationDtoToUpdate)
	};
}

function mapShoppingCartConfigurationBundleProductCharacteristicsToUpdate({
	characteristicGroups = [],
	characteristics = []
}: {
	characteristicGroups: ShoppingCartConfigurationBundleProductCharacteristicGroupDto[];
	characteristics: ShoppingCartConfigurationBundleProductCharacteristicDto[];
}): UpdateShoppingCartConfigurationBundleProductCharacteristicDto[] {
	const formattedCharacteristics = characteristics.map(mapShoppingCartConfigurationBundleProductCharacteristicDtoToUpdate);
	const formattedCharacteristicGroups = characteristicGroups.map((group) => {
		const { characteristics: groupCharacteristics = [] } = group;
		return groupCharacteristics.map(mapShoppingCartConfigurationBundleProductCharacteristicDtoToUpdate);
	});

	return [...formattedCharacteristics, ...formattedCharacteristicGroups.flat()];
}

function mapShoppingCartConfigurationBundleProductCharacteristicDtoToUpdate(characteristic: ShoppingCartConfigurationBundleProductCharacteristicDto) {
	const { name, qty } = characteristic;

	return { name, qty };
}

function mapShoppingCartConfigurationBundleProductServiceSpecificationDtoToUpdate(
	serviceSpecification: ShoppingCartConfigurationBundleProductServiceSpecificationDto
): UpdateShoppingCartConfigurationBundleProductServiceSpecificationDto {
	const { name, type, value } = serviceSpecification;
	const valueParsed = type === ServiceSpecificationType.STRING ? (String(value).length > 0 ? value : undefined) : value;

	return {
		name,
		value: valueParsed
	};
}
